import React from 'react';
import GenericDetail from '../genericDetail/GenericDetail';
import LocalAirportRoundedIcon from '@material-ui/icons/LocalAirportRounded';
import {ITicketDetailsWithTerms} from 'gui/components/editors/flightEditor/components/ticketDetailsForm';

interface IAdAirlineCompanyProps {
  ticketDetails: Partial<ITicketDetailsWithTerms>;
}

const AdAirlineCompany = (props: IAdAirlineCompanyProps) => (
  <GenericDetail
    title="חברת תעופה"
    icon={LocalAirportRoundedIcon}
  >
    {props.ticketDetails.originFlightCompany.name}
  </GenericDetail>
);

AdAirlineCompany.defaultProps = {
  ticketDetails: {},
};
export default AdAirlineCompany;
